import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import { localStorage } from 'lusha-widgets';
import { lazy } from 'react';
const DEFAULT_INTERVAL = 500;
const DEFAULT_RETRIES = 2;
const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
const fetchChunk = (componentImport, chunkName) => __awaiter(void 0, void 0, void 0, function* () {
    logger.info(`[lazyRetryReload]: chunk - ${chunkName} Fetching...`);
    const component = yield componentImport();
    localStorage.set(`chunk-${chunkName}-forced-reload`, false);
    return component;
});
export const lazyRetryReload = (componentImport, chunkName, retries = DEFAULT_RETRIES, interval = DEFAULT_INTERVAL) => lazy(() => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fetchChunk(componentImport, chunkName);
    }
    catch (error) {
        const pageHasAlreadyBeenForceRefreshed = localStorage.get(`chunk-${chunkName}-forced-reload`, false);
        if (!pageHasAlreadyBeenForceRefreshed) {
            // Lets retry loading this chunk
            // Problem might be user's network connection
            for (let retry = 0; retry < retries; retry++) {
                try {
                    logger.info(`[lazyRetryReload]: retry ${retry + 1}`);
                    yield wait(interval);
                    return yield fetchChunk(componentImport, chunkName);
                }
                catch (ignored) {
                    // Ignoring error here as we will reload if this persists
                }
            }
            // Assuming that the user is not on the latest version of the application.
            // Let's reload the page.
            logger.info(`[lazyRetryReload]: chunk - ${chunkName} reloading app`);
            localStorage.set(`chunk-${chunkName}-forced-reload`, true);
            // Reload only this frame: navigating window.parent would redirect the host tab
            // (to this frame's own URL when document.referrer is empty)
            window.location.reload();
        }
        else {
            // We retried the request to check for a network failure
            // The page has already been reloaded
            // Assuming that user is already using the latest version of the application.
            // Let's let the application crash and raise the error.
            logger.info(`[lazyRetryReload]: chunk - ${chunkName} throwing error...`);
            throw error;
        }
    }
}));
export default lazyRetryReload;
